// extracted by mini-css-extract-plugin
export default {"root":"_2LQQ9","small":"_2hYvF","normal":"_2aYW_"};